import { render } from "./list-desktop.vue?vue&type=template&id=c10e29ce"
import script from "./list-desktop.vue?vue&type=script&lang=js"
export * from "./list-desktop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__